import { render } from "./NotepadIcon.vue?vue&type=template&id=698878d8"
import script from "./NotepadIcon.vue?vue&type=script&lang=js"
export * from "./NotepadIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__